
export const productTypesOptions = [
  {
    value: "base",
    str: "Hoofdafbeelding",
  },
]

export const websiteTypesOptions = [
  {
    value: "websiteLogo",
    str: "Website-logo",
  },
  {
    value: "favicon",
    str: "Favicon",
  },
  {
    value: "banner",
    str: "Banner",
  },
  {
    value: "frontpage_01",
    str: "Voorpagina 1",
  },
  {
    value: "frontpage_02",
    str: "Voorpagina 2",
  },
]

export default {
  computed: {
    productTypesOptions() { return productTypesOptions },
    websiteTypesOptions() { return websiteTypesOptions },
  },
}
